module.exports = __webpack_public_path__ + "media/honey-icons/icon-humidity-bcc98e80.svg";